import accounting from "accounting";
import configs from "../configs/configs";
import {useSelector} from "react-redux";
import {getFormattedAmountWithDot} from "../store/selectors";
import Coins from "../components/common/CoinBalance";

const currencySymbols = {
  USD: "$",
  EUR: "€",
  TRY: "₺",
  TND: "DT",
  INR: "₹",
  NPR: "रु",
  BDT: "৳",
  BRL: "R$",
  AED: "AED",
};

export const getCurrencySymbol = (currency: string) => currencySymbols[currency] || "";

export const useFormatCurrency = () => {
  const formattedAmountWithDot = useSelector(getFormattedAmountWithDot);

  return (amount: number, currency: string) => {
    if ((currency === "FPP" || currency === "GOS") && amount >= 0) {
      return <Coins val={amount} type={currency}/>
    }
    if (formattedAmountWithDot) {
      return accounting
          .formatMoney(
              amount,
              configs.currencySymbol
                  ? configs.currencySymbol + " "
                  : getCurrencySymbol(currency) + " ",
              {
                precision: 0,
              }
          )
          .replace(/,/g, ".");
    } else {
      return accounting.formatMoney(
          amount,
          configs.currencySymbol
              ? configs.currencySymbol + " "
              : getCurrencySymbol(currency) + " "
      );
    }
  };
};
